import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scroll-in" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Input = _resolveComponent("Input")
  const _component_TrackerButtongroup = _resolveComponent("TrackerButtongroup")
  const _component_TrackerSegment = _resolveComponent("TrackerSegment")
  const _component_TrackerTextarea = _resolveComponent("TrackerTextarea")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    max_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => _cache[4] || (_cache[4] = [
      _createTextVNode(" Edit Topic ")
    ])),
    content: _withCtx(() => [
      _createVNode(_component_ScrollBar, {
        class: "content",
        "bar-x-offset": "0rem",
        fade: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("label", null, "Topic", -1 /* HOISTED */)),
              _createVNode(_component_Input, {
                modelValue: $data.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.name) = $event)),
                disabled: ""
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _createVNode(_component_TrackerSegment, {
              title: "TRACKER SENSITIVITY",
              tooltip: "signal_sensitivity"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TrackerButtongroup, {
                  modelValue: $data.tracker_focus,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.tracker_focus) = $event)),
                  options: $data.SENSITIVITY,
                  class: "button-group"
                }, null, 8 /* PROPS */, ["modelValue", "options"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_TrackerSegment, {
              title: "EMAIL ALERTS",
              tooltip: "email_notifications"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TrackerButtongroup, {
                  modelValue: $data.tracker_alerts,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.tracker_alerts) = $event)),
                  options: $data.ALERTS,
                  class: "button-group"
                }, null, 8 /* PROPS */, ["modelValue", "options"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_TrackerSegment, {
              title: "WHAT SHOULD WE WATCH FOR?",
              tooltip: "topic_customize_tracking"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TrackerTextarea, {
                  modelValue: $data.focus_on,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.focus_on) = $event)),
                  title: "Focus tracking on:",
                  placeholder: "e.g. product launches and partnerships",
                  class: "textarea"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        disabled: $data.loading,
        onClick: $options.close
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_submit,
        loading: $data.loading,
        onClick: $options.submit
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode(" Save ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "loading", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}